import { useEffect } from 'react';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

export const useForterScript = () => {
  const enableForterFraudTracking = useFlag(LaunchDarklyFlag.ENABLE_FORTER_FRAUD_TRACKING);

  useEffect(() => {
    if (enableForterFraudTracking) {
      const script = document.createElement('script');
      script.async = true;
      script.crossOrigin = 'anonymous';
      script.id = process.env.REACT_APP_RBI_FORTER_SITE_ID ?? '';
      script.src = '/forter.js';

      document.body.appendChild(script);
    }
  }, [enableForterFraudTracking]);
};
